<template>
  <modal type="text/x-template" id="modalFilterMobile">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-body">
              <div class="header-container" @click="$emit('close')">
                <img
                  src="../assets/before.svg"
                  width="30px"
                  height="30px"
                  class="header-container"
                />
                <h5 class="header-title">FILTRAR POR:</h5>
              </div>

              <div class="filter-content">
                <PillsComponent
                  :categories="categories"
                  :filterMobile="true"
                  @selectedCategory="selectedCategory"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>
import PillsComponent from "../components/PillsComponent";

export default {
  name: "ModalFilterMobile",
  props: {
    categories: {
      type: Array,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    selectedCategory(category) {
      this.$emit("onSelectedCategory", category);
    },
  },
  components: {
    PillsComponent,
  },
};
</script>

<style scoped>
.header-container {
  display: inline-flex;
  margin-bottom: 2vh;
}
.header-title {
  margin-left: 5px;
  margin-top: 7px;
  font-size: initial;
}
.filter-content {
  /* background: rgba(95, 106, 121, 0.06); */
  align-self: center;
}

.modal-xs-header-text.modal-xs-right-header-text {
  margin-left: 30px;
}
.modal-xs-header-text {
  display: inline-block;
  clear: both;
  font-size: 16px;
  text-transform: uppercase;
}
.modal-xs-header {
  color: #5f6a79;
  fill: #5f6a79;
}
.modal-xs-header {
  position: relative;
  display: block;
  padding: 15px;
  clear: both;
  text-decoration: none;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  hyphens: auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.modal-xs-header-icon.modal-xs-right-header-icon {
  left: 5px;
  right: initial;
}
.modal-xs-header-icon {
  position: absolute;
  top: 11px;
  right: 14px;
}

svg:not(:root) {
  overflow: hidden;
}
.fa-2x {
  font-size: 2em;
}
.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.header {
  width: 90%;
  margin-left: 10%;
  padding: 10px;
}

.modal-footer {
  display: inherit;
}

.produts-title {
  text-align: center;
  font-weight: bold;
}
.title {
  font-weight: 800;
}
.close-modal {
  width: 10%;
  text-align: end;
}
.button-close {
  background: red;
  border-radius: 20px;
  padding: 10px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  height: 100%;
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  min-width: fit-content;
  overflow-y: auto;
}

.modal-header {
  margin-top: 0;
  color: #212529;
  text-align: center;
  justify-content: center;
  align-self: center;
}

.modal-body {
  /* margin: 5px 0;
  padding: 5%; */
}

.container-button {
  padding: 15px;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/components/ModalFilterMobile.vue